// api client
import { client } from '../api/client'

// types
import { InitializeData} from '../types/initializeTypes'

// helpers
import { getMostRecentUserOnBoardings } from '../helpers/initializeHelper'




/**
 * Initialize app data
 *
 * @returns Promise<InitializeData>
 */
const initialize = (store:any): Promise<InitializeData> => {
  return new Promise(async (resolve, reject) => {
    try {
      //const response = await client.get('/initialization')
      
      const url = store ? `/initialization?storeId=${store}` : '/initialization';
      const response = await client.get(url)

      if (response.status === 200) {
        
        
        
        const initializeData: InitializeData = {
          mostRecentUserOnBoardings: getMostRecentUserOnBoardings( response.data.userOnBoardings),
         
          states: response.data.localLookups.states,
          genders: response.data.localLookups.genders,
          maritalStatuses: response.data.localLookups.maritalStatuses,
          relationships: response.data.localLookups.relationships,
          schedules: response.data.localLookups.schedules,
          permittedUploadExtensions: response.data.permittedUploadExtensions,
          staticDocumentPath: response.data.staticDocumentPath,
          userkey:response.data.essUserKey,
          userEmployees:response.data.userEmployees
        }
       
        
       
        resolve(initializeData)
        
      } else {
        reject({ message: 'Could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const initializeService = {
  initialize,
}
